module.exports = __webpack_public_path__ + "img/wave-top.05d52988.png";